module.exports = __webpack_public_path__ + "img/alert-circle.8ad7b3c4.svg";